const TIMER_STEP_SECONDS = 60;
const MAX_TIMER_SECONDS = 2 * 60 * 60; // 2 hours, matching saved breakout durations
const MIN_TIMER_SECONDS = 1 * 60; // 1 minute minimum

/**
 * Parse "MM:SS" or "M:SS" string to total seconds.
 * Returns null if invalid.
 */
export const parseMmSs = (value: string): number | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const parts = trimmed.split(":");
  if (parts.length === 1) {
    const minutes = parseInt(parts[0], 10);
    if (!Number.isNaN(minutes) && minutes >= 0) return minutes * 60;
    return null;
  }
  if (parts.length === 2) {
    const minutes = parseInt(parts[0], 10);
    const seconds = parseInt(parts[1], 10);
    if (
      !Number.isNaN(minutes) &&
      !Number.isNaN(seconds) &&
      minutes >= 0 &&
      seconds >= 0 &&
      seconds < 60
    ) {
      return minutes * 60 + seconds;
    }
    return null;
  }
  return null;
};

/**
 * Format seconds to "MM:SS".
 */
export const formatSecondsToMmSs = (totalSeconds: number): string => {
  const mins = Math.floor(totalSeconds / 60);
  const secs = Math.floor(totalSeconds % 60);
  return `${mins}:${String(secs).padStart(2, "0")}`;
};

export { TIMER_STEP_SECONDS, MAX_TIMER_SECONDS, MIN_TIMER_SECONDS };
